import React, { useMemo } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useFormContext } from 'react-hook-form'
import { Question } from '@verzekeringapp-mono/shared/src/models/value_meter_question'
import { laravelValidate } from '@verzekeringapp-mono/shared/src/utils/laravel_validation'

export const RadioInput = ({
  name,
  options,
  hint,
  rules,
  disabled
}: {
  name: string
  options: Question['options']
  hint?: string
  rules?: string
  disabled?: boolean
}) => {
  const { register, watch } = useFormContext()

  const validationOptions = useMemo(
    () =>
      rules
        ? {
          validate: laravelValidate(rules)
        }
        : undefined,
    [rules]
  )

  if (!options) return null

  return (
    <div>
      <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-4'>
        {options.map(option => {
          const isSelected = watch(name) === option.value

          return (
            <label
              key={option.value}
              className={`flex items-center space-x-2 rounded-lg border p-4 ${
                disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'
              } ${
                isSelected
                  ? 'border-border-brand bg-surface-brand-subtle text-text-primary'
                  : 'border-border-default bg-surface-input text-text-primary'
              }`}
            >
              <input
                type='radio'
                className='form-radio hidden'
                {...register(name, validationOptions)}
                value={option.value}
                disabled={disabled}
              />

              <div
                className={`flex h-6 w-6 aspect-square items-center justify-center rounded-full border bg-surface-card ${
                  isSelected
                    ? 'border-border-brand'
                    : 'border-border-default'
                }`}
              >
                {isSelected && (
                  <FontAwesomeIcon
                    icon='check'
                    className='text-icon-brand'
                  />
                )}
              </div>

              <span className='text-text-primary'>
                {option.label}
              </span>
            </label>
          )
        })}
      </div>

      {hint && <p className='my-2 text-text-secondary'>{hint}</p>}
    </div>
  )
}
